import React, { useEffect, useState, useContext } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Button } from "react-bootstrap";

import Utils from "../../../Utils";
import ContextComponent from "../../../AppContext";
import DefaultQRCode from "./../../../../assets/img/qrcode.png";
import downloadImage from "./../../../../assets/img/Upload.png";

const QRCode = (props) => {
  let [cardData, setCardData] = useState(props.cardData || {});
  let [cardId, setCardId] = useState(props.cardId || "");

  const { setAlert, setLoadingState, setCanRedirectToLogin } = useContext(ContextComponent);

  let [canRender, setCanRender] = useState(false);
  let [qrCode, setQrCode] = useState(DefaultQRCode);

  useEffect(() => {
    if (!Utils.isObjectEmpty(cardData)) {
      setQrCode(cardData.qrCode || DefaultQRCode);
      setCanRender(true);
    }
  }, [cardData]);

  const copyLinkHandler = (e) => {
    window.open(props.cardExtLink, "_blank", "noopener,noreferrer");
  };

  const downloadQRCodeStandard = (e) => {
    downloadQRCode(300, 'standard');
  };

  const downloadQRCodeLarge = (e) => {
    downloadQRCode(600, 'large');
  };

  const downloadQRCode = (size, namePostFix) => {
    const downloadSuccess = (res) => {
      if (!Utils.isObjectEmpty(res.data)) {
        setLoadingState({
          applyMask: false,
        });

        let link = document.createElement("a");
        link.download = `${cardData.publicId}_${namePostFix}.png`;
        link.href = res.data;
        link.click();
        URL.revokeObjectURL(link.href);
      } else {
        setLoadingState({
          applyMask: false,
        });
      }
    };
    const downloadFail = ({ error }) => {
      error?.message?.length && console.log(error);
      // setErrorMessage(error);
      Utils.handleDefaultError({
        error,
        setLoadingState,
        setCanRedirectToLogin,
      });
    };

    setLoadingState({
      applyMask: true,
      text: "Downloading qrcode",
    });
    Utils.downloadQRCode(cardData.publicId, size).then(
      downloadSuccess,
      downloadFail
    );
  };

  const downloadQRCodeBlur = (e) => {
    // take any image
    let img = document.querySelector(
      "img.indi-card-item-page2-qrcode-image-tag"
    );

    // make <canvas> of the same size
    let canvas = document.createElement("canvas");
    canvas.width = 100;
    canvas.height = 100;

    let context = canvas.getContext("2d");

    // copy image to it (this method allows to cut image)
    context.scale(100 / 100, 100 / 100);
    context.drawImage(img, 0, 0);
    // we can context.rotate(), and do many other things on canvas

    // toBlob is async operation, callback is called when done
    canvas.toBlob(function (blob) {
      // blob ready, download it
      let link = document.createElement("a");
      link.download = "qrCode.png";

      link.href = URL.createObjectURL(blob);
      // link.href = qrCode;
      link.click();

      // delete the internal blob reference, to let the browser clear memory from it
      URL.revokeObjectURL(link.href);
    }, "image/png");
  };

  return (
    <>
      {canRender && (
        <>
          <div className="indi-card-item-page2-qrcode-image">
            <img
              className="indi-card-item-page2-qrcode-image-tag"
              src={qrCode}
              alt="qrcode"
            />
          </div>

          <div className="indi-card-item-page2-qrcode-download-image-wrapper">
            <span className="">
              <b>Download: </b>
            </span>
            {/* <img
              className="indi-card-item-page2-qrcode-download-image indi-card-item-page2-qrcode-download-image-small"
              onClick={downloadQRCodeSmall}
              src={downloadImage}
              alt="download"
            /> */}
            {/* <span onClick={ downloadQRCodeSmall } className="indi-card-item-page2-qrcode-download-image indi-card-item-page2-qrcode-download-image-small" role="button">Small</span> */}
            <span
              onClick={downloadQRCodeStandard}
              className="indi-card-item-page2-qrcode-download-image indi-card-item-page2-qrcode-download-image-medium"
              role="button"
            >
              Standard
            </span>{" "}
            |
            <span
              onClick={downloadQRCodeLarge}
              className="indi-card-item-page2-qrcode-download-image indi-card-item-page2-qrcode-download-image-large"
              role="button"
            >
              Large
            </span>
            {/* <img
              className="indi-card-item-page2-qrcode-download-image indi-card-item-page2-qrcode-download-image-medium"
              onClick={downloadQRCodeMedium}
              src={downloadImage}
              alt="download"
            /> */}
            {/* <img
              className="indi-card-item-page2-qrcode-download-image indi-card-item-page2-qrcode-download-image-large"
              onClick={downloadQRCodeLarge}
              src={downloadImage}
              alt="download"
            /> */}
          </div>

          <div className="indi-card-item-page2-scan-or-click">
            Scan or click to preview
          </div>

          <div className="indi-card-item-page2-copy-link-btn">
            <CopyToClipboard text={props.cardExtLink}>
              <Button variant="light" onClick={copyLinkHandler}>
                Copy Link
              </Button>
            </CopyToClipboard>
          </div>
        </>
      )}
    </>
  );
};

export default QRCode;
